export default __webpack_public_path__ + "static/media/eachImgCross.d827a294.svg";